import { render, staticRenderFns } from "./RecipientsListModal.vue?vue&type=template&id=b50d26fe&"
import script from "./RecipientsListModal.vue?vue&type=script&lang=js&"
export * from "./RecipientsListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports